<template>
    <div>
        <div class="main-internal-section width-full float-l">
            <div class="container">
                <template v-if="cantAccessPage === true">
                    <MailDetail v-bind:url="url"></MailDetail>
                </template>
                <template v-else>
                    <template>
                        <div class="col-md-12">
                            <div class="error-template">
                                <h1>
                                    Oops!</h1>
                                <h2>
                                    403 </h2>
                                <div class="error-details">
                                    Sorry!, You don't have permission to access this page.
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import {HTTP} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    import EventBus from '../event-bus';
    import '@alpesh.savitriya/pseudomailer/dist/pseudomailer.css';
    import { Components } from '@alpesh.savitriya/pseudomailer';
    var contex;
    export default {
        components: {
        },
        name: 'MailList',
        mixins: [commonMixins],
        data: () => ({
            cantAccessPage: true,
            // url: "http://vvg.chat.com/api/v1",
            url: process.env.ROOT_API,
        }),
        beforeMount: function () {
            contex = this;
        },
        mounted: function() {
            var self = this;
            EventBus.$emit("headerMobileView", 'Mail List');
            self.getPermissions();
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Users/MailList.vue